import { buildWaLink } from "./api";
import { toast } from "sonner";

// Kebijakan: WAHA HANYA untuk pesan otomatis (laporan lunas, pengingat absen, bulk reminder — diatur di Pengaturan).
// Semua pengiriman manual dari tombol aplikasi selalu membuka WhatsApp lokal (wa.me).
export const sendWaSmart = async ({ phone, text }) => {
  if (!phone) { toast.error("Nomor WhatsApp kosong"); return; }
  window.open(buildWaLink(phone, text), "_blank");
};
